import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from 'react-router-dom';
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import DownloadBtnSaleInvoicePdf from "../../Invoices/Sale/DownloadBtnSaleInvoicePdf";
import PrintBtnSaleInvoicePdf from "../../Invoices/Sale/PrintBtnSaleInvoicePdf";
import DownloadBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/DownloadBtnSaleReturnInvoicePdf";
import PrintBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/PrintBtnSaleReturnInvoicePdf";

let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: '#',
    field: 'srNo',
    width: 20,
    attributes: {
    'aria-controls': 'DataTable',
    'aria-label': '#',
    },
  },
  {
    label: "Date",
    field: "invoice_date",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Date",
    },
  },
  {
    label: "Ref No.",
    field: "ref_no",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Ref No.",
    },
  },
  {
    label: "Name",
    field: "name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Name",
    },
  },
  {
    label: "Category",
    field: "category",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Category",
    },
  },
  {
    label: "Type",
    field: "type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "type",
    },
  },
  {
    label: "Money In",
    field: "money_in",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Money In",
    },
  },
  {
    label: "Money Out",
    field: "money_out",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Money Out",
    },
  },
  // {
  //   label: "Running Cash In Hand",
  //   field: "running_amount",
  //   width: 100,
  //   attributes: {
  //     "aria-controls": "DataTable",
  //     "aria-label": "Running Cash In Hand",
  //   },
  // },
  {
    label: "Action",
    field: "actionExtra",
    width: 100,
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class cashflowReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      paidAmount: 0,
      unpaidAmount: 0,
      total: 0,
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      dateLabel: "",
      pageCount : 25,
      page : 1,
      totalCount  : 0,
      pageShow  : 0,
      totalClosingCashInHand  : 0,
      totalMoneyIn  : 0,
      totalMoneyOut  : 0,
      totalOpeningCashInHand  : 0,
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getSaleListData(this.state.activeTransactionKey,this.state.page,this.state.pageCount);
  }

  getSaleListData(_type,_page,pageCount) {
    let _transArray = [];
    let _totalAmt = 0;

    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      type: _type,
      isDateFilter: true,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      pageCount: pageCount,
      page: _page,
    });
    PostData(global.userCashflowTransactionList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            total: _totalAmt,
            countList: 0,
            totalClosingCashInHand  : 0,
            totalMoneyIn  : 0,
            totalMoneyOut  : 0,
            totalOpeningCashInHand  : 0,
          });
        } else {
          if (responseJson.response) {
            _transArray = responseJson.response;
            _transArray.map((itm, i) => {
            });
          }
          let _totalOpeningCashInHand  = responseJson.totalOpeningCashInHand ? responseJson.totalOpeningCashInHand : 0;
          let closingCashInHand = (parseFloat(_totalOpeningCashInHand) + parseFloat(responseJson.totalMoneyIn)) -  parseFloat(responseJson.totalMoneyOut);
          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            totalClosingCashInHand: closingCashInHand,
            totalMoneyIn: responseJson.totalMoneyIn,
            totalMoneyOut: responseJson.totalMoneyOut,
            totalOpeningCashInHand: _totalOpeningCashInHand,
            total: _totalAmt,
            countList: responseJson.countList,
            totalCount: responseJson.totalCount,
            pageShow: responseJson.pageShow,
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadTranscListing() {
    let dataList = [];
    let rows = [];
    let _i=0;
    if (this.state.isLoaded == true) {
      let _transDetails = this.state.transactionArrayFilter;
      if (_transDetails.length > 0) {
        _transDetails.map((value, index) => {
          _i++; 
          let _textShow = "Credit Note";
          if (value.type == "SALE") {
            _textShow = "Sale";
          }
          let _money_in = value.money_in ? value.money_in : '';
          let _money_out = value.money_out ? value.money_out : '';
          let _running_amount = value.running_amount ? value.running_amount : '';
          let OpenigCash =  0;

          let _editActionUrl =
            global.webUrl + "business/add-sale/?auth=" + value.id;
          let _editDuplicateActionUrl =
            global.webUrl + "business/add-sale/?auth=" + value.id + '&tType=DUPLICATE';
          if (value.type == "SALE") {
            _editActionUrl =
              global.webUrl + "business/add-sale/?auth=" + value.id;
            _editDuplicateActionUrl =
              global.webUrl + "business/add-sale/?auth=" + value.id + '&tType=DUPLICATE';
          } else if (value.type == "CREDIT NOTE") {
            _editActionUrl =
              global.webUrl + "business/add-sale-credit-note/?auth=" + value.id;
            _editDuplicateActionUrl =
              global.webUrl +
              "business/add-sale-return-duplicate/?auth=" +
              value.id;
          }
          let _actionExtra = "";
          if (value.type == "SALE") {
            _actionExtra = (
              <div className="btn-group" role="group">
                <button
                  type="button"
                  id="btnGroupVerticalDrop3"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="btnGroupVerticalDrop1"
                >
                  <a className="dropdown-item" href={_editDuplicateActionUrl}>
                    Duplicate
                  </a>
                  <a className="dropdown-item" href={_editActionUrl}>
                    View/Edit Details
                  </a>
                  <a
                    className="dropdown-item"
                    href={
                      global.webUrl +
                      "business/add-receive-payment-in/?auth=" +
                      value.id
                    }
                  >
                    Receive Payment
                  </a>
                  {/* canCreateReturn is false once every line is fully returned */}
                  {value.canCreateReturn !== false && (
                    <a
                      className="dropdown-item"
                      href={
                        global.webUrl +'business/add-sale-credit-note?auth='+value.id+"&tType=CREDIT NOTE&isConvert=true"
                      }
                    >
                      Convert to Return
                    </a>
                  )}
                  <a
                    className="dropdown-item"
                    href="javascript:void(0)"
                    data-id={value.id}
                    onClick={this.clickToDelete.bind(this, value.id, "Sale")}
                  >
                    Delete
                  </a>
                  <a
                    className="dropdown-item"
                    href={
                      global.webUrl + "business/challanPdfDialog/?auth=" + value.id
                    }
                    target="_blank"
                  >
                    Preview as Delivery Challan
                  </a>
                  <DownloadBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  <Link className="dropdown-item" to={'/business/salePdfDialog/?auth='+value.id} target="_blank">
                      Preview
                  </Link>
                  <PrintBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  {/* <ButtonPdf transactionId={value.id} isChallanPreview={true}/> */}
                </div>
              </div>
            );
          }
           else if (value.type == "CREDIT NOTE") {
            _actionExtra = (
              <div className="btn-group" role="group">
                <button
                  type="button"
                  id="btnGroupVerticalDrop3"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="btnGroupVerticalDrop1"
                >
                  <a className="dropdown-item" href={_editActionUrl}>
                    View/Edit Details
                  </a>
                  <a
                    className="dropdown-item"
                    href="javascript:void(0)"
                    data-id={value.id}
                    onClick={this.clickToDelete.bind(
                      this,
                      value.id,
                      "CREDIT NOTE"
                    )}
                  >
                    Delete
                  </a>
                  <a className="dropdown-item" href={_editDuplicateActionUrl}>
                    Duplicate
                  </a>
                  <a
                    className="dropdown-item"
                    href={
                      global.webUrl +
                      "business/add-make-payment-out/?auth=" +
                      value.id
                    }
                  >
                    Make Payment
                  </a>
                  <DownloadBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  <Link className="dropdown-item" to={'/business/saleReturnPdfDialog/?auth='+value.id} target="_blank">
                      Preview
                  </Link>
                  <PrintBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  {/* <ButtonPdf transactionId={value.id} isChallanPreview={true}/> */}
                </div>
              </div>
            );
          }
           else {
            _actionExtra = (
              <div className="btn-group" role="group">
                <button
                  type="button"
                  id="btnGroupVerticalDrop3"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-ellipsis-v"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="btnGroupVerticalDrop1"
                >
                  <a className="dropdown-item" href={_editDuplicateActionUrl}>
                    Duplicate
                  </a>
                  <a
                    className="dropdown-item"
                    href={
                      global.webUrl +
                      "business/add-make-payment-out/?auth=" +
                      value.id
                    }
                  >
                    Make Payment
                  </a>
                  <DownloadBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  <Link className="dropdown-item" to={'/business/salePdfDialog/?auth='+value.id} target="_blank">
                      Preview
                  </Link>
                  <PrintBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                  {/* <ButtonPdf transactionId={value.id}/> */}
                </div>
              </div>
            );
          }

          let _saleType = <span className="badge badge-warning">UNPAID</span>;

          let _pageAK = 1;
          rows.push({
            srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
            invoice_date: moment(value.invoice_date).format("YYYY-MM-DD"),
            ref_no: value.invoice_no, //value.customPrefix+' #'+value.invoice_no,
            name: value.party_name,
            sale_type: _textShow,
            type: value.type,
            payment_type: value.payment_type,
            total_amount: numberFormat(value.total_amount),
            money_in: _money_in,
            money_out: _money_out,
            //running_amount : _running_amount,
            actionExtra: _actionExtra,
          });
        });
      }
    }

    if (rows) {
      dataList = {
        columns: columns,
        rows: rows,
      };
    }
    return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData(this.state.activeTransactionKey,this.state.page,this.state.pageCount);
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData(this.state.activeTransactionKey,this.state.page,this.state.pageCount);
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Cashflow Report</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <div className="text-info">
                                  <i className="fa fa-file-excel-o"></i>
                                </div>
                                <div className="font-size-sm text-muted">
                                  Excel Export
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-6">
                          <div className="row pb-20 pull-right">
                              <div className="text-right">
                                <div className="js-appear-enabled text-center">
                                  <div className="" style={{color : 'green'}}>
                                      Opening Cash In Hand : {numberFormat(this.state.totalOpeningCashInHand)}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                         
                        <div className="col-lg-6">                          
                          <div className="row pb-20 pull-right">
                              <div className="text-right">
                                <div className="js-appear-enabled text-center">
                                  <div className="" style={{color : 'green'}}>
                                  Closing Cash in Hand : {numberFormat(this.state.totalClosingCashInHand)}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>    
                      </div>
                    </div>
                    
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-6">
                          <div className="row pb-20 pull-right">
                              <div className="text-right">
                                <div className="js-appear-enabled text-center">
                                  <div className="" style={{color : 'green'}}>
                                  Total Money In : {numberFormat(this.state.totalMoneyIn)}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                                          
                        <div className="col-lg-6">                          
                          <div className="row pb-20 pull-right">
                              <div className="text-right">
                                <div className="js-appear-enabled text-center">
                                  <div className="" style={{color : 'red'}}>
                                      Total Money Out : {numberFormat(this.state.totalMoneyOut)}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                                         
                          
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                        <i className="fa fa-plus-circle"></i> Add Sale
                    </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    {/* <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100]}
                      entries={25}
                      pagesAmount={4}
                      span
                      pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    /> */}
                    
                      <MDBDataTableV5
                          hover
                          span
                          displayEntries={false}
                          entries={100}
                          pagingTop={false}
                          searchTop={false}
                          searchBottom={false}
                          info={false}
                          barReverse
                          data={this.loadTranscListing()}
                      />
                  </div>
                  
                  <div style={{ float: "right", marginTop: "-15px" }}>
                      <div className="d-flex align-items-center justify-content-end">
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Rows per page:</div>
                          </div>
                          <div className="d-flex align-items-center" >
                          <select className=" d-flex align-items-center custom-select custom-select-sm form-control form-control-sm"
                                  onChange={(event) => {
                                      event.preventDefault();
                                      const { name, value } = event.target;
                                      //this.setState({ pageCount: value, setPage: 1 });
                                      this.setState(prevState => ({
                                              pageCount : value,
                                              setPage : 1,
                                          }),
                                          () => {
                                              this.getSaleListData(this.state.activeTransactionKey,1,value);
                                          });
                                  }}>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                              <option value="1000">1000</option>
                          </select>
                          </div>
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Total: {this.state.totalCount}</div>
                          </div>
                      </div>
                  </div>
                  <div className="block-content">
                      <div style={{ float: "left", marginTop: "-45px" }}>
                      <PaginationControl
                          between={this.state.pageCount}
                          total={this.state.totalCount}
                          limit={this.state.pageCount}
                          changePage={(page) => {
                          this.setState({ setPage: page });
                          this.getSaleListData(this.state.activeTransactionKey,page,this.state.pageCount);
                          }}
                          ellipsis={1}
                          activeClass={this.state.setPage}
                          page={this.state.setPage}
                      />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
